/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BobbinQuantityViewModel } from '../../models/bobbin-quantity-view-model';

export interface GetBobbinQuantity$Params {
  productionOrderId: number;
}

export function getBobbinQuantity(http: HttpClient, rootUrl: string, params: GetBobbinQuantity$Params, context?: HttpContext): Observable<StrictHttpResponse<BobbinQuantityViewModel>> {
  const rb = new RequestBuilder(rootUrl, getBobbinQuantity.PATH, 'get');
  if (params) {
    rb.path('productionOrderId', params.productionOrderId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BobbinQuantityViewModel>;
    })
  );
}

getBobbinQuantity.PATH = '/api/v1/SetupParameter/GetBobbinQuantity/{productionOrderId}';
